"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CalendarDays } from "lucide-react";
export default function BookATable() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="223017" id="247-rapid-response" className="relative w-full py-24 lg:py-32 overflow-hidden flex items-center justify-center min-h-[60vh] dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-blue-900/40 blur-md scale-110" aria-hidden="true" />
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold text-white mb-10 tracking-tighter drop-shadow-2xl max-w-4xl">Contact Our Team Today.</h2>

        <div className="relative inline-flex group mt-2">
          {}
          <div className="absolute inset-0 rounded-lg bg-ring animate-ping opacity-30 duration-1000"></div>
          
          <Button asChild size="lg" className="relative h-16 px-10 rounded-md text-lg md:text-xl font-default font-bold bg-ring text-white shadow-2xl transition-transform group-hover:scale-105 border-none">
            <Link to="tel:+353894000413">
              <CalendarDays className="mr-2 size-6" />
              Call Now: +353 894000413
            </Link>
          </Button>
        </div>

        <p className="mt-8 text-accent-foreground font-mono text-lg md:text-xl drop-shadow-md tracking-wider uppercase">
          Rapid Response Across the Region
        </p>
      </div>
    </section>;
}